<template>
  <!-- Main Content -->
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />

    <v-row class="d-flex justify-end">
      <!-- Tanggal Awal & Akhir -->
      <v-col cols="2">
        <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              readonly
              v-model="startDate"
              label="Tanggal Awal"
              v-bind="attrs"
              v-on="on"
              dense
              outlined
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            @input="onDateChange('start')"
            locale="id"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="2">
        <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              label="Tanggal Akhir"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              outlined
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            @input="onDateChange"
            locale="id"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <!-- Summary Cards -->
    <v-row>
      <v-col
        class="clickable-card"
        @click="goTo(card.status)"
        cols="12"
        sm="12"
        md="4"
        v-for="card in summaryCards"
        :key="card.title"
      >
        <v-card :color="card.color" dark>
          <v-card-text>
            <div class="text-h5">{{ card.title }}</div>
            <div class="text-h3">{{ card.value }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <!-- Bar Chart divisi-->
      <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-title>Ide Setiap Department</v-card-title>
          <v-card-text>
            <canvas id="barChart"></canvas>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Bar Chart Site-->
      <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-title>Ide Setiap Lokasi Kerja</v-card-title>
          <v-card-text>
            <canvas id="barChartSite"></canvas>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Pie Chart atasan VS smo-->
      <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-title
            >Persentase Ide Di Setujui Atasan VS Di Setujui OEI
          </v-card-title>
          <v-card-text>
            <canvas id="pieChartValidation"></canvas>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Pie Chart smo VS implemented -->
      <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-title
            >Persentase Ide Di Setujui OEI VS Implementasi</v-card-title
          >
          <v-card-text>
            <canvas id="pieChartValidationOeiVsImplemented"></canvas>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Line Chart -->
      <!-- <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-title>Ide Setiap Bulan</v-card-title>
          <v-card-text>
            <canvas id="lineChart"></canvas>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import api from "@/utils/api";
import store from "@/store";
import { getThisYearRange } from "@/utils/date";

import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  PieController,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

// Registrasi komponen Chart.js
Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  PieController,
  ArcElement,
  Tooltip,
  Legend
);

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      chartDataEachMonth: null, // Data dari API akan disimpan di sini
      chartDataEachDivision: null, // Data dari API akan disimpan di sini
      chartDataEachSite: null, // Data dari API akan disimpan di sini
      chartDataValidation: null, // Data dari API akan disimpan di sini
      chartDataValidationOeiVsImplemented: null, // Data dari API akan disimpan di sini
      countSuggestion: {
        total: 0,
        submitted: 0,
        approved: 0,
        rejected: 0,
      },
      startMenu: false,
      endMenu: false,
      startDate: getThisYearRange().start,
      endDate: getThisYearRange().end,
    };
  },

  methods: {
    triggerSnackbar(message, isSuccess) {
      store.dispatch("triggerSnackbar", { message, isSuccess });
    },
    fetchCountSuggestion() {
      api
        .get(
          `/dashboard/count-suggestion?startDate=${this.startDate}&endDate=${this.endDate}`
        )
        .then(({ data }) => {
          this.countSuggestion = data.data[0];

          // console.log(this.countSuggestion);
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    // async fetchChartDataEachMonth() {
    //   try {
    //     const response = await api.get(
    //       "/dashboard/count-suggestion/each-month"
    //     );
    //     return response.data; // Sesuaikan dengan format data dari API
    //   } catch (error) {
    //     console.error("Error fetching chart data:", error);
    //     throw error; // Lempar error agar bisa ditangani di `mounted`
    //   }
    // },

    async fetchChartDataEachDivision() {
      try {
        const response = await api.get(
          `/dashboard/count-suggestion/each-division?startDate=${this.startDate}&endDate=${this.endDate}`
        );
        return response.data; // Sesuaikan dengan format data dari API
      } catch (error) {
        console.error("Error fetching chart data:", error);
        throw error; // Lempar error agar bisa ditangani di `mounted`
      }
    },
    async fetchChartDataEachSite() {
      try {
        const response = await api.get(
          `/dashboard/count-suggestion/each-site?startDate=${this.startDate}&endDate=${this.endDate}`
        );
        return response.data; // Sesuaikan dengan format data dari API
      } catch (error) {
        console.error("Error fetching chart data:", error);
        throw error; // Lempar error agar bisa ditangani di `mounted`
      }
    },
    async fetchchartDataValidation() {
      try {
        const response = await api.get(
          `/dashboard/count-suggestion/validation?startDate=${this.startDate}&endDate=${this.endDate}`
        );
        return response.data; // Sesuaikan dengan format data dari API
      } catch (error) {
        console.error("Error fetching chart data:", error);
        throw error; // Lempar error agar bisa ditangani di `mounted`
      }
    },
    async fetchchartDataValidationOeiVsImplemented() {
      try {
        const response = await api.get(
          `/dashboard/count-suggestion/validation-oei-implemented?startDate=${this.startDate}&endDate=${this.endDate}`
        );
        return response.data; // Sesuaikan dengan format data dari API
      } catch (error) {
        console.error("Error fetching chart data:", error);
        throw error; // Lempar error agar bisa ditangani di `mounted`
      }
    },
    // createChartsLine() {
    //   let line = [];
    //   let labels = [];
    //   this.chartDataEachMonth.forEach((element) => {
    //     line.push(element.total);
    //     labels.push(element.month_name);
    //   });

    //   // console.log(this.chartDataEachMonth);

    //   // Line Chart
    //   const lineCtx = document.getElementById("lineChart").getContext("2d");
    //   new Chart(lineCtx, {
    //     type: "line",
    //     data: {
    //       labels: labels,
    //       datasets: [
    //         {
    //           label: "Jumlah Ide",
    //           data: line,
    //           borderColor: "rgba(54, 162, 235, 1)",
    //           borderWidth: 2,
    //           fill: false,
    //         },
    //       ],
    //     },
    //     options: {
    //       responsive: true,
    //     },
    //   });
    // },
    createChartsBar() {
      let bar = [];
      let labels = [];
      this.chartDataEachDivision.forEach((element) => {
        bar.push(element.total);
        labels.push(element.mst_division_name);
      });

      // Bar Chart
      const barCtx = document.getElementById("barChart").getContext("2d");
      new Chart(barCtx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Jumlah Ide",
              data: bar,
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    },
    createChartsBarSite() {
      let bar = [];
      let labels = [];
      this.chartDataEachSite.forEach((element) => {
        bar.push(element.total);
        labels.push(element.mst_site_name);
      });

      // Bar Chart
      const barCtx = document.getElementById("barChartSite").getContext("2d");
      new Chart(barCtx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Jumlah Ide",
              data: bar,
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    },
    createChartsPieValidation() {
      let pie = [];
      let labels = [];
      this.chartDataValidation.forEach((element) => {
        pie.push(element.total);
        labels.push(element.last_status);
      });

      // console.log(this.chartDataValidation);
      // Pie Chart
      const pieCtx = document
        .getElementById("pieChartValidation")
        .getContext("2d");
      new Chart(pieCtx, {
        type: "pie",
        data: {
          labels: labels,
          datasets: [
            {
              data: pie,
              backgroundColor:
                pie.length === 1
                  ? ["#b8860b"]
                  : ["#b8860b", "rgb(76, 175, 80)"],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (tooltipItem) {
                  let dataset = tooltipItem.dataset;
                  let total = dataset.data.reduce((acc, val) => acc + val, 0);
                  let value = dataset.data[tooltipItem.dataIndex];
                  let percentage = ((value / total) * 100).toFixed(2);
                  return `${tooltipItem.label}: ${percentage}% (${value})`;
                },
              },
            },
          },
        },
      });
    },
    createChartsPieValidationOeiVsImplemnted() {
      let pie = [];
      let labels = [];
      this.chartDataValidationOeiVsImplemented.forEach((element) => {
        pie.push(element.total);
        labels.push(element.last_status);
      });

      // console.log(this.chartDataValidationOeiVsImplemented);

      // Pie Chart
      const pieCtx = document
        .getElementById("pieChartValidationOeiVsImplemented")
        .getContext("2d");
      new Chart(pieCtx, {
        type: "pie",
        data: {
          labels: labels,
          datasets: [
            {
              data: pie,
              backgroundColor: [
                "rgb(76, 175, 80)",
                "#36A2EB",
                "#FFCE56",
                "#4BC0C0",
                "#9966FF",
                "#FF9F40",
              ],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (tooltipItem) {
                  let dataset = tooltipItem.dataset;
                  let total = dataset.data.reduce((acc, val) => acc + val, 0);
                  let value = dataset.data[tooltipItem.dataIndex];
                  let percentage = ((value / total) * 100).toFixed(2);
                  return `${tooltipItem.label}: ${percentage}% (${value})`;
                },
              },
            },
          },
        },
      });
    },
    goTo(status) {
      if (this.$route.name !== "reportStatus") {
        this.$router.push({
          name: "reportStatus",
          query: {
            status: status,
            itemsPerPage: -1,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });
      }
    },
    updatePagination(query) {
      this.startDate = query.startDate || this.startDate;
      this.endDate = query.endDate || this.endDate;
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.endDate); // Update endDate
      }
      location.reload();
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    this.updatePagination(this.$route.query);

    // this.fetchChartDataEachMonth()
    //   .then((data) => {
    //     this.chartDataEachMonth = data.data; // Simpan data ke state
    //     this.createChartsLine(); // Buat grafik setelah data diterima
    //   })
    //   .catch((error) => {
    //     console.error("Gagal memuat data grafik:", error);
    //   });
    this.fetchChartDataEachDivision().then((data) => {
      this.chartDataEachDivision = data.data; // Simpan data ke state
      this.createChartsBar();
    });
    this.fetchChartDataEachSite().then((data) => {
      this.chartDataEachSite = data.data; // Simpan data ke state
      this.createChartsBarSite();
    });
    this.fetchchartDataValidation()
      .then((data) => {
        this.chartDataValidation = data.data; // Simpan data ke state
        this.createChartsPieValidation();
      })
      .catch((error) => {
        console.error("Gagal memuat data grafik:", error);
      });
    this.fetchchartDataValidationOeiVsImplemented()
      .then((data) => {
        this.chartDataValidationOeiVsImplemented = data.data; // Simpan data ke state
        this.createChartsPieValidationOeiVsImplemnted();
      })
      .catch((error) => {
        console.error("Gagal memuat data grafik:", error);
      });
    store.commit("setTitle", "Dashboard");
    this.fetchCountSuggestion();
  },
  computed: {
    summaryCards() {
      return [
        // {
        //   title: "Total",
        //   value: this.countSuggestion.total || 0, // Default ke 0 jika undefined
        //   color: "dark grey",
        // },
        {
          title: "Waiting Approval",
          status: "Waiting Approval",
          value: this.countSuggestion.waiting_approval || 0,
          color: "grey",
        },
        {
          title: "Need To Analysis",
          status: "Need To Analysis",
          value: this.countSuggestion.waiting_nta || 0,
          color: "warning",
        },

        {
          title: "Approved Atasan",
          status: "Approved Atasan",
          value: this.countSuggestion.approved_atasan || 0,
          color: "#b8860b",
        },

        {
          title: "Approved OEI",
          status: "Approved Operation Excellence & Improvement",
          value: this.countSuggestion.approved_oei || 0,
          color: "green",
        },

        {
          title: "implemented",
          status: "implemented",
          value: this.countSuggestion.Implemented || 0,
          color: "rgb(33, 150, 243)",
        },
        {
          title: "Rejected",
          status: "rejected",
          value: this.countSuggestion.rejected || 0,
          color: "red",
        },
      ];
    },
  },
};
</script>

<style scoped>
.clickable-card {
  cursor: pointer;
}
</style>
